<ng-container>
  <div class="page-header" [ngClass]="{'page-header-home':template == 'home'}"  id="HeaderSlider">
    <div class="carrousel"  *ngIf="page && page.acf?.carrousel">
      <swiper
        #slider
        [pagination]="page.acf.carrousel.length>1"
        [config]="sliderConfig"
        *ngIf="page.acf.carrousel.length>1"
      >
          <ng-template swiperSlide *ngFor="let carrousel of page.acf.carrousel; let i = index">
            <div [ngStyle]="{'display': slider?.swiperRef?.realIndex == i? 'block' : 'none'}">
              <media-attachment [priority]="true" [forceCopyright]="true" [displayCopyright]="true" *ngIf="carrousel.image" [attachment]="carrousel.image|attachmentFromId|async"></media-attachment>
              <media-attachment [priority]="true" [loop]="true" [forceCopyright]="false" [displayCopyright]="false" *ngIf="carrousel.video" [attachment]="carrousel.video|attachmentFromId|async"></media-attachment>
              <div class="carrousel-home-content bayadares-after bayadares-before"  *ngIf="page && template === 'home'" >
                <h1 *ngIf="i==0" class="carrousel-home-content-title" [innerHTML]="carrousel.title"></h1>
                <p *ngIf="i>0" class="carrousel-home-content-title" [innerHTML]="carrousel.title"></p>
              </div>
            </div>
          </ng-template>
      </swiper>
      <div *ngIf="page.acf.carrousel.length===1">
        <media-attachment [priority]="true" [forceCopyright]="true" [displayCopyright]="true" *ngIf="page.acf.carrousel[0].image" [attachment]="page.acf.carrousel[0].image|attachmentFromId|async"></media-attachment>
        <media-attachment [priority]="true" [loop]="true" [forceCopyright]="false" [displayCopyright]="false" *ngIf="page.acf.carrousel[0].video" [attachment]="page.acf.carrousel[0].video|attachmentFromId|async"></media-attachment>
        <div class="carrousel-home-content bayadares-after bayadares-before"  *ngIf="page && template === 'home'" >
          <h1 class="carrousel-home-content-title" [innerHTML]="page.acf.carrousel[0].title"></h1>
        </div>
      </div>
    </div>
    <div class="grid grid-section intro-container " *ngIf="page && template !== 'home'">
      <div class="content reverse bayadares-before">
        <h1 class="h1" [innerHTML]="page.title.rendered"></h1>
        <div class="intro" [innerHTML]="page.content.rendered"></div>
        <breacrumbs [postId]="page.id" *ngIf="page"></breacrumbs>
      </div>
    </div>
    <div class="page-navigation-container" *ngIf="template === 'home'">
      <div class="grid grid-section p-0">
        <page-navigation *ngIf="page && page.acf && page.acf.navigation" [navigation]="page.acf.navigation"></page-navigation>
      </div>
    </div>
  </div>
  <div class="page-navigation-container" *ngIf="template !== 'home'">
    <div class="grid grid-section">
      <page-navigation *ngIf="page && page.acf && page.acf.navigation" [navigation]="page.acf.navigation"></page-navigation>
    </div>
  </div>
  <div class="page-sections" *ngIf="page">
    <ng-container *ngFor="let section of page.acf?.sections; let i = index">
      <text-images-section *ngIf="section.acf_fc_layout == WP_PAGE_ACF_FC_Layouts.TEXT_IMAGES" [section]="section" [index]="i+1"></text-images-section>
      <selection-sit-section *ngIf="section.acf_fc_layout ==  WP_PAGE_ACF_FC_Layouts.SELECTION_SIT" [section]="section" [index]="i+1"></selection-sit-section>
      <evenement-sit-section *ngIf="section.acf_fc_layout ==  WP_PAGE_ACF_FC_Layouts.EVENEMENTS_SIT" [section]="section" [index]="i+1"></evenement-sit-section>
      <list-pages-section *ngIf="section.acf_fc_layout ==  WP_PAGE_ACF_FC_Layouts.LIST_PAGES" [section]="section" [children]="page.children" [siblings]="page.siblings" [index]="i+1"></list-pages-section>
      <list-links-section *ngIf="section.acf_fc_layout ==  WP_PAGE_ACF_FC_Layouts.LIST_LINKS" [section]="section" [index]="i+1"></list-links-section>
      <bookmarks-section *ngIf="section.acf_fc_layout ==  WP_PAGE_ACF_FC_Layouts.BOOKMARKS" [section]="section" [index]="10000"></bookmarks-section>
      <currently-section *ngIf="section.acf_fc_layout ==  WP_PAGE_ACF_FC_Layouts.CURRENTLY" [section]="section" [index]="i+1"></currently-section>
      <context-section *ngIf="section.acf_fc_layout ==  WP_PAGE_ACF_FC_Layouts.CONTEXT" [section]="section" [index]="i+1"></context-section>
      <free-section *ngIf="section.acf_fc_layout ==  WP_PAGE_ACF_FC_Layouts.FREE" [section]="section" [index]="i+1"></free-section>
      <newsletter-section *ngIf="section.acf_fc_layout ==  WP_PAGE_ACF_FC_Layouts.NEWSLETTER" [section]="section" [index]="i+1"></newsletter-section>
      <itineraire-section *ngIf="section.acf_fc_layout ==  WP_PAGE_ACF_FC_Layouts.ITINERARY" [section]="section" [index]="i+1"></itineraire-section>
    </ng-container>
    <newsletter-section *ngIf="hasDefaultNewsletterSection"></newsletter-section>
  </div>
</ng-container>

